import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

export const fetchSecurazeSolutionsCount = (params) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post("/securaze-solution/count", params);
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data && res.data.message ? res.data.message : "Cannot fetch securaze solutions."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchSecurazeSolutions = (params) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post("/securaze-solution/list", params);
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            };
            snackActions.snackBar({
                message: `${res && res.data && res.data.message ? res.data.message : "Could not fetch securaze solutions."}`,
                options: {
                    variant: 'warning'
                }
            });
            return []
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}

export const updateSecurazeSolution = (params) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/securaze-solution/update', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data && res.data.message ? res.data.message : "Cannot edit securaze solution."}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return {};
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};


export const fetchSecurazeSolution = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/securaze-solution/load', params);
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data && res.data.message ? res.data.message : "Cannot fetch securaze solution"}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return {};
            }

        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

export const createSecurazeSolution = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('/securaze-solution/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res.data && res.data.message ? res.data.message : "Successfully created securaze solution."}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data && res.data.message ? res.data.message : "Cannot create securaze solution."}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return {};
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

export const bulkDeleteSecurazeSolutions = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/securaze-solution/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully deleted securaze solutions.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete securaze solutions."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}
